import React, { useEffect, useState, useRef, use } from "react";

// Import images from src/assets folder (adjust paths if needed)
import loaderImg from "../assets/images/loader.png";


// THEME CSS FILES ENDS HERE
// COMMON COMPONENTS DEFINED AT ONE PLACE FOR GOD'S OWN COUNTRY
import MenuLinks from "./Menu";
// Logo Trial Final From My Side
import logoLight from "../assets/images/Bharat_Dhara/Logo/bd_white_font_png_noslogan.png";
import logoDark from "../assets/images/resources/logo-1.png";

import home1 from "../assets/images/update-20-12-2021/home-sections/home-1.jpg";
import home2 from "../assets/images/update-20-12-2021/home-sections/home-2.jpg";
import home3 from "../assets/images/update-20-12-2021/home-sections/home-3.jpg";
import home4 from "../assets/images/update-20-12-2021/home-sections/home-4.jpg";

function Header({ menuWrapperRef, menuContentRef }) {
  const targetRef = useRef(null); // reference to the element to change overflow
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isTab, setIsTab] = useState(window.innerWidth < 1200);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  // LOADER REMOVAL
  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);

      if (targetRef.current) {
        targetRef.current.style.overflow = "visible";
      }
    }, 2000); // 2 seconds for demo

    return () => clearTimeout(timer);
  }, []);

  // TOGGLE MOBILE AND WEB MENU
  useEffect(() => {
    const handleResize = () => {
      setIsTab(window.innerWidth < 1200);
      setIsMobile(window.innerWidth < 768);
    };

    window.addEventListener("resize", handleResize);

    // Call it initially to set on first render
    handleResize();

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const mobileMenuClick = () => {
    const wrapper = menuWrapperRef.current;
    const isExpanded = wrapper?.classList.contains("expanded");

    if (!isExpanded) {
      // Menu is being opened
      document.querySelector("#root").classList.add("overflow-hidden");
      wrapper.classList.add("expanded");

      // ✅ Add event listener only when opened
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      // Menu is being closed
      closeMenu();
    }
  };

  const closeMenu = () => {
    document.querySelector("#root").classList.remove("overflow-hidden");
    menuWrapperRef.current?.classList.remove("expanded");
    document.removeEventListener("mousedown", handleClickOutside);
  };

  const handleClickOutside = (event) => {
    if (
      menuContentRef.current &&
      !menuContentRef.current.contains(event.target)
    ) {
      closeMenu();
    }
  };
  return (
    <section>
      {loading && (
        <div className="preloader">
          <img
            className="preloader__image"
            width="60"
            src={loaderImg}
            alt="Loading..."
          />
        </div>
      )}
      <div ref={targetRef} className="page-wrapper">
        <header className="main-header main-header--one main-header--one--two clearfix">
          <div className="main-header--one__wrapper">
            <div className="main-header--one__bottom clearfix">
              <div className="auto-container">
                <div className="main-header--one__bottom-inner">
                  <div className="main-header--one__bottom-middel">
                    <div className="logo">
                      <a href="index-main.html">
                        <img
                          src={logoLight}
                          alt="Logo Light"
                          className="bd-logo light-logo"
                        />
                        {/* <imgs
                          src={logoDark}
                          alt="Logo Dark"
                          className="dark-logo"
                        /> */}
                      </a>
                    </div>
                  </div>

                  <nav className="main-menu main-menu--1">
                    <div className="main-menu__inner">
                      <div className="stricky-one-logo">
                        <div className="logo">
                          <a href="index-main.html">
                            <img
                              src={logoDark}
                              alt="Logo Dark"
                              className="dark-logo"
                            />
                            {/* <img
                              src={logoLight}
                              alt="Logo Light"
                              className="light-logo"
                            /> */}
                          </a>
                        </div>
                      </div>

                      {isTab == true ? (
                        <a
                          href="#"
                          onClick={() => mobileMenuClick()}
                          className="mobile-nav__toggler"
                        >
                          <i className="fa fa-bars"></i>
                        </a>
                      ) : (
                        <div className="main-header--one__bottom-left">
                          <MenuLinks />
                        </div>
                      )}
                    </div>
                  </nav>

                  <div className="main-header--one__bottom-right clearfix">
                    <div className="search-cart">
                      <a href="#" className="search search-toggler">
                        <span className="icon-magnifying-glass"></span>
                      </a>
                      <a href="#" className="cart mini-cart__toggler">
                        <span className="icon-shopping-cart"></span>
                      </a>
                    </div>
                    <div className="contact-box">
                      <div className="icon">
                        <span className="icon-phone-call-2"></span>
                      </div>
                      <div className="text">
                        <p>Call Anytime</p>
                        <a href="tel:123456789">666 888 0000</a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </header>
        <div className="stricky-header stricked-menu main-menu">
          <div className="sticky-header__content"></div>
        </div>
      </div>
    </section>
  );
}

export default Header;
